<template>
  <div id="app">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {},
  provide() {
    return {
      reload: this.reload,
    }
  },

  data() {
    return {
      isRouterAlive: true,
    }
  },

  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function() {
        this.isRouterAlive = true
      })
    },
  },
}
</script>

<style>
html,
body,
#app {
  height: 100%;
  background-color: white;
  font-family: sans-serif;
}
body {
  margin: initial;
  min-width: 1280px;
}
#nprogress .bar {
  background: #ff6c02 !important;
}
</style>
